<template>
  <v-skeleton-loader v-if="loading"
                     type="card"/>
  <content-card v-else
                :title="$t('user-management-card.title').toString()"
                icon="group_add">
    <template v-slot:content>
      <v-card-text class="pa-5">
        <span v-html="$t('user-management-card.description')"/>
        <div class="mt-4 font-weight-bold d-flex align-center">
          <v-icon color="primary" class="mr-2">
            person
          </v-icon>
          {{ $t('user-management-card.active-users', {activeUsersAmount: activeUsersAmount}) }}
        </div>
        <div v-if="permissionExpired" class="mt-4 font-weight-bold d-flex align-center">
          <v-icon color="primary" class="mr-2">
            warning
          </v-icon>
          {{ permissionExpirationDescription }}
        </div>
        <div class="pt-5">
          <v-btn plain block
                 color="primary"
                 class="font-weight-bold"
                 to="userManagement">
            {{ $t('user-management-card.button') }}
          </v-btn>
        </div>
      </v-card-text>
    </template>
  </content-card>
</template>

<script>

import ContentCard from "@/templates/components/ContentCard.vue";
import config from "@/config/config.app.json";
import requestHelper from "@/scripts/requestHelper"

export default {
  name: "UserManagementCard",
  components: {ContentCard},
  props: [],

  data() {
    return {
      loading: false,
      invitedUsers: null,
      pendingInvitations: null,
      timer: null
    }
  },
  methods: {
    /**
     * gets invited users from the API
     *
     * @param showLoader
     */
    getData(showLoader) {
      if (showLoader) {
        this.loading = true
      }
      this.$rhRequest.sendGet({
            endpoint: 'settings/get-registered-users',
          }, (resp) => {
            this.invitedUsers = resp?.data?.data?.registered
            this.loading = false
          },
          (error) => {
            console.error('Failed to get invited users:', error)
          })

      this.$rhRequest.sendGet({
            endpoint: 'settings/get-invited-users',
          }, (resp) => {
            this.pendingInvitations = resp?.data?.data?.invited
            this.loading = false
          },
          (error) => {
            console.error('Failed to get pending invitations: ', error)
          })
    },

    /**
     * continuously updates the data
     */
    updateData() {
      this.timer = setInterval(() => {
        this.getData(false)
      }, config.updateInterval)
    },
  },
  computed: {
    activeUsersAmount() {
      return this.invitedUsers?.length + this.pendingInvitations?.length - 1
    },
    allUsers() {
      let allUsers = []
      // Iterrate over this.invitedUsers and this.pendingInvitations, add all values to allUsers
      for (let user of this.invitedUsers) {
        allUsers.push(user)
      }
      for (let user of this.pendingInvitations) {
        allUsers.push(user)
      }
      return allUsers
    },
    permissionExpired() {
      let permissionExpirations = this.permissionExpirations
      return Object.values(permissionExpirations).some(deadline => deadline > 0)
    },
    permissionExpirationDescription() {
      let permissionExpirations = this.permissionExpirations;
      if (permissionExpirations['2'] > 0) {
        if (permissionExpirations['2'] === 1) {
          return this.$t('user-management-card.permission-expiration-description.one-permission-two-days')
        } else {
          return this.$t('user-management-card.permission-expiration-description.multiple-permissions-two-days', {count: permissionExpirations['2']})
        }
      } else if (permissionExpirations['7'] > 0) {
        if (permissionExpirations['7'] === 1) {
          return this.$t('user-management-card.permission-expiration-description.one-permission-seven-days')
        } else {
          return this.$t('user-management-card.permission-expiration-description.multiple-permissions-seven-days', {count: permissionExpirations['7']})
        }
      } else if (permissionExpirations['0'] > 0) {
        if (permissionExpirations['0'] === 1) {
          return this.$t('user-management-card.permission-expiration-description.one-permission-expired')
        } else {
          return this.$t('user-management-card.permission-expiration-description.multiple-permissions-expired', {count: permissionExpirations['0']})
        }
      }
      return null
    },
    permissionExpirations() {
      let expirationDeadlines = {
        0: 0,
        2: 0,
        7: 0
      }
      let allUsers = this.allUsers
      for (let user of allUsers) {
        if (user.role === 'ADMIN') {
          continue
        }
        if (!user.valid_to) {
          continue
        }
        let expirationDate = new Date(user.valid_to)
        let currentDate = new Date()
        for (let days of Object.keys(expirationDeadlines)) {
          if (expirationDate.getTime() - currentDate.getTime() <= parseInt(days) * 24 * 60 * 60 * 1000) {
            expirationDeadlines[days]++
            break
          }
        }
      }
      return expirationDeadlines
    }
  },

  mounted() {
    this.loading = true
    requestHelper.startDelayedRequest(
        () => this.getData(true),
        () => this.updateData()
    )
  },

  beforeDestroy() {
    clearInterval(this.timer)
  },
}
</script>

<style scoped>

</style>